import React from 'react';
import BlogPostItem from '@/components/BlogPostItem';
import Button from '@/components/Button';
import { useTranslation } from 'next-i18next';
import Title from '@/components/Title';
import useGTM from '@/hooks/useGtag';
import { traceEvent } from '@wk/wk-gatherer';
import useBlogList from '@/hooks/useBlogList';
import { Post } from '@/request/interface/common';

const Index = () => {
  const { t, i18n } = useTranslation(['chinese']);
  const { blogList } = useBlogList({
    storeName: `blog-list-chinese-${i18n.language}`,
    cat_id: i18n.language === 'zh' ? '1' : '134691',
  });
  const sendDataToGTM = useGTM();
  const handleGA = (gaName?: string, extra: { [key: string]: any } = {}) => {
    // 获取当前路径
    const gaNameFix = `O_ChineseCourse_Blog_${gaName}`;
    sendDataToGTM(gaNameFix);
    traceEvent({
      data: {
        _event: gaNameFix,
        ...extra,
      },
    });
  };

  const handleClick = (data: Post) => {
    handleGA('ArticleClick', {
      article_name: data?.post_title,
      article_type: data?.post_id,
      Article_url: data?.post_link,
    });
  };

  return (
    <div className=" container mt-20 lg:mt-[140px] xl:mt-[180px]">
      <Title className="mb-6 lg:mb-15" innerHTML theme="red">
        {t('中文-博客-标题')}
      </Title>
      <BlogPostItem post={blogList} handleClick={handleClick} />
      <div className="text-center">
        <Button
          href={t('path:博客')}
          target="_blank"
          size="xl"
          className="mt-6 lg:mt-12 xl:mt-[60px] [&]:text-base [&]:font-medium [&]:xl:text-xl"
          traceName="O_ChineseCourse_Blog_MoreClick"
        >
          {t('home:博客-按钮')}
        </Button>
      </div>
    </div>
  );
};

export default Index;
